import axios from 'axios'
import { clearSession } from '@/utils/session'

const UNAUTHORIZED_TEXT = /未登录|请先登录|登录失效|登录已失效|令牌无效|token.*(?:失效|过期)|无权访问|未授权/i
let authRedirecting = false

const service = axios.create({
  baseURL: '/api',
  timeout: 15000,
  headers: { 'Content-Type': 'application/json' }
})

service.interceptors.request.use(config => {
  const token = localStorage.getItem('bf_token')
  if (token) config.headers.Authorization = `Bearer ${token}`
  return config
}, error => Promise.reject(error))

service.interceptors.response.use(response => {
  if (response.config.responseType === 'blob') return response
  const res = response.data
  if (res.code !== 200) {
    const error = new Error(res.msg || '请求异常')
    error.data = res.data
    error.code = res.code
    if (!response.config.skipAuthRedirect && isUnauthorized(res.code, res.msg)) {
      invalidateAndRedirect()
    }
    return Promise.reject(error)
  }
  return res
}, error => {
  const status = error.response && error.response.status
  const config = error.config || {}
  if (!config.skipAuthRedirect && (status === 401 || status === 403)) {
    invalidateAndRedirect()
  }
  return Promise.reject(error)
})

function isUnauthorized(code, message) {
  return code === 401 || code === 403 || (code !== 200 && UNAUTHORIZED_TEXT.test(message || ''))
}

function invalidateAndRedirect() {
  if (authRedirecting) return
  authRedirecting = true
  clearSession('unauthorized')
  if (window.location.pathname !== '/') window.location.replace('/')
  window.setTimeout(() => { authRedirecting = false }, 1200)
}

export function request(options) { return service(options) }
export const get = (url, params, options = {}) => request({ url, method: 'get', params, ...options })
export const post = (url, data, options = {}) => request({ url, method: 'post', data, ...options })
